// extracted by mini-css-extract-plugin
export var curved = "heroDivider-module--curved--B9t_d";